module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Jungle Minds Christmas 2019","short_name":"JM Christmas 2019","start_url":"/","background_color":"#E61B30","theme_color":"#E61B30","display":"minimal-ui","icon":"src/images/favicon.svg"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
